/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardSafetyIncidentCounts
 */
export interface DashboardSafetyIncidentCounts {
    /**
     * 
     * @type {number}
     * @memberof DashboardSafetyIncidentCounts
     */
    impacts: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSafetyIncidentCounts
     */
    severeImpacts: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSafetyIncidentCounts
     */
    stationaryZoneViolations: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSafetyIncidentCounts
     */
    vehicleZoneViolations: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSafetyIncidentCounts
     */
    badgeZoneViolations: number;
}

/**
 * Check if a given object implements the DashboardSafetyIncidentCounts interface.
 */
export function instanceOfDashboardSafetyIncidentCounts(value: object): value is DashboardSafetyIncidentCounts {
    if (!('impacts' in value) || value['impacts'] === undefined) return false;
    if (!('severeImpacts' in value) || value['severeImpacts'] === undefined) return false;
    if (!('stationaryZoneViolations' in value) || value['stationaryZoneViolations'] === undefined) return false;
    if (!('vehicleZoneViolations' in value) || value['vehicleZoneViolations'] === undefined) return false;
    if (!('badgeZoneViolations' in value) || value['badgeZoneViolations'] === undefined) return false;
    return true;
}

export function DashboardSafetyIncidentCountsFromJSON(json: any): DashboardSafetyIncidentCounts {
    return DashboardSafetyIncidentCountsFromJSONTyped(json, false);
}

export function DashboardSafetyIncidentCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSafetyIncidentCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'impacts': json['impacts'],
        'severeImpacts': json['severeImpacts'],
        'stationaryZoneViolations': json['stationaryZoneViolations'],
        'vehicleZoneViolations': json['vehicleZoneViolations'],
        'badgeZoneViolations': json['badgeZoneViolations'],
    };
}

export function DashboardSafetyIncidentCountsToJSON(json: any): DashboardSafetyIncidentCounts {
    return DashboardSafetyIncidentCountsToJSONTyped(json, false);
}

export function DashboardSafetyIncidentCountsToJSONTyped(value?: DashboardSafetyIncidentCounts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'impacts': value['impacts'],
        'severeImpacts': value['severeImpacts'],
        'stationaryZoneViolations': value['stationaryZoneViolations'],
        'vehicleZoneViolations': value['vehicleZoneViolations'],
        'badgeZoneViolations': value['badgeZoneViolations'],
    };
}

